import { useEffect } from "react";
import { Overlay, OverlayPanel } from "./styles";
import closeIcon from "./imgs/close-icon.svg";

const titleIdFrom = (title) =>
  `overlay-title-${String(title).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

const OverlayShell = ({ title, image, onClose, children }) => {
  const titleId = titleIdFrom(title);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  useEffect(() => {
    if (!onClose) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <Overlay
      role="presentation"
      onClick={onClose ? () => onClose() : undefined}
    >
      <OverlayPanel
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="overlay-hero">
          <img src={image} alt="" />
          <h2 id={titleId}>{title}</h2>
        </div>
        {onClose && (
          <button
            className="close-button"
            type="button"
            onClick={onClose}
            aria-label="Close"
          >
            <img src={closeIcon} alt="" />
          </button>
        )}
        <div className="scroll-view">{children}</div>
      </OverlayPanel>
    </Overlay>
  );
};

export default OverlayShell;
